module.exports = __webpack_public_path__ + "img/delete-photo.f7b75907.svg";